// src/components/admin/payroll/PayrollProcess.js
import React, { useState } from 'react';
import { X, AlertCircle } from 'lucide-react';

const PayrollProcess = ({ month, year, onClose, onProcess }) => {
    const [processing, setProcessing] = useState(false);

    const handleProcess = async () => {
        setProcessing(true);
        await onProcess();
        setProcessing(false);
    };

    const monthName = new Date(year, month - 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen px-4">
                <div className="fixed inset-0 bg-gray-500 opacity-75" onClick={onClose}></div>

                <div className="relative bg-white rounded-lg max-w-md w-full p-6">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-bold">Process Payroll</h2>
                        <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                            <X className="w-6 h-6" />
                        </button>
                    </div>

                    <div className="space-y-4">
                        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                            <div className="flex items-start">
                                <AlertCircle className="w-5 h-5 text-yellow-600 mr-2 flex-shrink-0 mt-0.5" />
                                <div>
                                    <h3 className="text-sm font-medium text-yellow-800">Confirm Payroll Processing</h3>
                                    <p className="text-sm text-yellow-700 mt-1">
                                        You are about to process payroll for <strong>{monthName}</strong>.
                                        This action will calculate salaries for all active employees.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-2">
                            <div className="flex justify-between text-sm">
                                <span className="text-gray-600">Processing Month:</span>
                                <span className="font-medium">{monthName}</span>
                            </div>
                            <div className="flex justify-between text-sm">
                                <span className="text-gray-600">Total Employees:</span>
                                <span className="font-medium">50</span>
                            </div>
                            <div className="flex justify-between text-sm">
                                <span className="text-gray-600">Estimated Total:</span>
                                <span className="font-medium">$425,000</span>
                            </div>
                        </div>

                        <div className="flex justify-end gap-2 pt-4">
                            <button
                                onClick={onClose}
                                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleProcess}
                                disabled={processing}
                                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                            >
                                {processing ? 'Processing...' : 'Process Payroll'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PayrollProcess;